module.exports = __webpack_public_path__ + "static/videozz-876a09b0526d89290e77eaf03309ef3b.png";